import { h, defineComponent, ref, watch } from 'vue';
import { IdProps } from '@/ui/helpers/uiHelper';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { renderAnalyticsTeaserPage } from '@/ui/pages/teasers/AnalyticsTeaserPage';
import { renderForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
import { box, container, loader } from '@/ui/components';
import PhotoGallery from '@/_legacy/views/Analytics/Checklist/PhotoGallery.vue';
import { fetchQuestion } from '@/services/api/resources/analytics';
import { useTask } from '@/ui/concerns';
import { useCurrentRoute } from '@/ui/routes';

type questionResponse = { uuid: string; photos: Array<{ inspection_question_uuid: string }> };
type questionsResponse = Array<questionResponse>;

export const SummaryChecklistsPhotosPage = defineComponent<IdProps>({
  name: 'SummaryChecklistsPhotosPage',
  props: ['id'],
  setup(props) {
    if (!hasFeature('analytics')) {
      return renderAnalyticsTeaserPage;
    }

    if (!hasPermission(Permissions.VIEW_ALL_ANALYTICS)) {
      return renderForbiddenPage;
    }

    const currentRoute = useCurrentRoute();
    const questionParam = ref<string>(currentRoute.value.query.question!.toString());
    const fetchedQuestion = ref<questionResponse>();

    // get record
    const getRecord = useTask(
      () => fetchQuestion(props.id.toString(), questionParam.value),
      async response => {
        // eslint-disable-next-line prefer-destructuring
        fetchedQuestion.value = ((response.parsed as { data: unknown }).data as questionsResponse)[0];
      },
    );
    watch([ref(props.id), questionParam], getRecord.run);

    return function render() {
      return h('div', [
        h('div', [
          container(
            [
              box([
                loader('div', getRecord, [
                  // @ts-ignore
                  fetchedQuestion.value ? h(PhotoGallery, {
                    class: 'legacy',
                    props: {
                      question: fetchedQuestion.value || {},
                    },
                  }) : null,
                ]),
              ]),
            ],
          ),
        ]),
      ]);
    };
  },
});
